export const CHANNEL_EMAIL = 'email';
export const CHANNEL_FB = 'facebook';
export const CHANNEL_INSTAGRAM = 'instagram';
export const CHANNEL_ONLINE_STORE = 'online store';
export const CHANNEL_WHATSAPP = 'whatsapp';

/**
 * @enum {string}
 */
export const CHANNEL = {
  ONLINE_STORE: CHANNEL_ONLINE_STORE,
  EMAIL: CHANNEL_EMAIL,
  FACEBOOK: CHANNEL_FB,
  INSTAGRAM: CHANNEL_INSTAGRAM,
  WHATSAPP: CHANNEL_WHATSAPP
};

export const BASE_URL_FACEBOOK_GRAPH = 'https://graph.facebook.com';
export const BASE_URL_FACEBOOK = 'https://www.facebook.com';

export const hasChannelEmail = ({channels = []}) => channels.includes(CHANNEL_EMAIL);
export const hasChannelFacebook = ({channels = []}) => channels.includes(CHANNEL_FB);
export const hasChannelInstagram = ({channels = []}) => channels.includes(CHANNEL_INSTAGRAM);
export const hasChannelOnlineStore = ({channels = []}) => channels.includes(CHANNEL_ONLINE_STORE);
export const hasChannelWhatsApp = ({channels = []}) => channels.includes(CHANNEL_WHATSAPP);

/**
 * @param {App.ChatConversation} conversation
 * @returns {boolean}
 */
export const isChannelWebsite = ({channels = []}) => {
  if (!channels.length || hasChannelOnlineStore({channels})) return true;
  return ![CHANNEL_EMAIL, CHANNEL_FB, CHANNEL_INSTAGRAM, CHANNEL_WHATSAPP].some(c =>
    channels.includes(c)
  );
};

/**
 * @param {App.ChatConversation} conversation
 * @param {App.WidgetSetting} widgetSettings
 * @returns {boolean}
 */
export const isAvailableAIAssignee = ({channels = []}, widgetSettings) => {
  if (!channels.length || hasChannelOnlineStore({channels})) return true;
  if (hasChannelEmail({channels})) return hasChannelEmail(widgetSettings.aiAssistantSettings);
  return !hasChannelWhatsApp({channels});
};

export const isChannelSocial = ({channels = []}) => {
  return (
    hasChannelFacebook({channels}) ||
    hasChannelInstagram({channels}) ||
    hasChannelWhatsApp({channels})
  );
};

/**
 * @param {App.WidgetSetting} settings
 * @returns {boolean}
 */
export const isAIChannelEmail = settings => {
  const {isEnableAIAssistant, aiAssistantSettings = {}} = settings;
  return isEnableAIAssistant && hasChannelEmail(aiAssistantSettings);
};

export const DEFAULT_SIGNATURE = `<p><strong><span class="variable">{{full_name}}</span></strong><br><span class="variable">{{store_name}}</span></p>`;
